export default {
  deliveries: 'Доставки',
  delivery: 'Доставка',
  showFullShipmentHistory: 'Показать всю историю',
  hideFullShipmentHistory: 'Скрыть историю',
  lastShipment: 'Последняя отгрузка',
  driver: 'Водитель',
  vehicle: 'Транспортное средство',
  weight: 'Вес',
  volume: 'Объем',
  freight: 'Фрахт',
  meter: 'м',
  showCargo: 'Посмотреть груз',
  quantity: 'Количество',
  unit: 'ЕИ',
  warehouse: 'Склад',
  noShipments: 'В выбранном периоде нет доставок',
  searchByDeliveryId: 'Поиск по номеру доставки',
  loadType: 'Тип загрузки',
  backLoad: 'Снизу',
  aboveLoad: 'Сверху',
  sideLoad: 'Сбоку',
  selectPeriod: 'Выбрать период',
  orders: 'Заказы',
  call: 'Позвонить',
  copy: 'Копировать',
};
